import React from "react";
import classnames from "classnames";
import globalStyles from "@whatslly/ui-components/v2/globalStyles";
import styles from "./CrmIcon.module.scss";
import type { LoginProviderType } from "@whatslly/types/LoginProviderType";
import { AppIds } from "@whatslly/types/LoginProviderType";
import { Svg } from "../v2/BaseElements/Svg";

interface CrmIconProps {
  crm: LoginProviderType;
  className?: string;
}

export const CrmIcon: React.FC<CrmIconProps> = ({ crm, className }) => (
  <span className={classnames(styles.anchorIconContainer, className)}>
    {crm === AppIds.SALESFORCE ? (
      <Svg
        iconName={`salesforce`}
        className={classnames(
          styles.salesForceIcon,
          globalStyles["bg-color-neutral-secondary"],
          globalStyles["hover-bg-color-neutral-primary"],
          globalStyles["dark-mode-hover-bg-color-main-primary"]
        )}
      />
    ) : (
      <Svg
        iconName={`microsoft-dynamics`}
        className={classnames(
          styles.salesForceIcon,
          globalStyles["bg-color-neutral-secondary"],
          globalStyles["hover-bg-color-neutral-primary"],
          globalStyles["dark-mode-hover-bg-color-main-primary"]
        )}
      />
    )}
  </span>
);
